var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"balance-history-komads","frameborder":"1","height":"1000px","width":"100%","scrolling":"no","src":(_vm.url + "/komads/ctwa/balance-history")}})}
var staticRenderFns = []

export { render, staticRenderFns }